import o from "./SidebarElement.vue2.js";
/* empty css                    */
import t from "../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-a89ac4ec"]]);
export {
  m as default
};
